import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/mocks/gossip";

function BrandMark() {
  return (
    <a href="#top" className="flex items-center gap-2.5" aria-label="今日瓜报 首页">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-lg font-bold text-background-50 shadow-soft">
        瓜
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl font-bold tracking-tight">今日瓜报</span>
        <span className="mt-1 text-[11px] font-medium tracking-wide text-foreground-500">
          事件盘点 · 合集时间线
        </span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const darkTop = !scrolled;

  return (
    <header
      id="top"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/80 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <BrandMark />

        <ul className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((item) => (
            <li key={item.id}>
              <a
                href={item.anchor}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  darkTop
                    ? "text-background-100/90 hover:bg-background-100/10 hover:text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#contact"
            className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-bold transition-colors ${
              darkTop
                ? "bg-background-50 text-primary-600 hover:bg-accent-100"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            开始追更
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors lg:hidden ${
            darkTop ? "text-background-50 hover:bg-background-100/10" : "text-foreground-800 hover:bg-background-100"
          }`}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </nav>

      {open && (
        <div className="mx-4 mb-4 rounded-2xl border border-background-200 bg-background-50 p-4 shadow-soft lg:hidden">
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((item) => (
              <li key={item.id}>
                <a
                  href={item.anchor}
                  onClick={() => setOpen(false)}
                  className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 flex w-full items-center justify-center whitespace-nowrap rounded-xl bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 hover:bg-primary-600"
          >
            开始追更
          </a>
        </div>
      )}
    </header>
  );
}